import searchParamsStringify from "@Utils/searchParamsStringify";

function buildSearchListPager (searchParams, totalMatches, searchUrl, appConfig) {
  const currentPage = searchParams.page ? searchParams.page : 1;
  const pager = {
    previous: {},
    next: {},
    pages: [],
    current: currentPage,
  };

  const itemsPerPage = appConfig && appConfig.elements_per_page ? parseInt(appConfig.elements_per_page) : parseInt(process.env.REACT_APP_SEARCH_ITEMS_PER_PAGE);
  const pages = Math.ceil(totalMatches / itemsPerPage);
  let page = 1;
  const pageNumbers = pages > 5 ? 4 : pages;

  // Build link to previous page.
  if (searchParams.page > 1) {
    let pagerBuilder = Object.assign({}, searchParams);
    pagerBuilder.page = parseInt(pagerBuilder.page) - 1;
    if (pagerBuilder.page === 1) {
      pagerBuilder.page = null;
    }
    let url = `${searchUrl}${searchParamsStringify(pagerBuilder)}`;

    pager.previous = {
      url: url,
      // mousedown: dataLayer.buildPaginationClickEvent(pagerBuilder.page),
    }
  }

  // Build link for next page.
  if (pages > 1 && (searchParams.page === 0 || searchParams.page < pages || !searchParams.page)) {
    let pagerBuilder = Object.assign({}, searchParams);
    pagerBuilder.page = pagerBuilder.page ? parseInt(pagerBuilder.page) + 1 : 2;
    let url = `${searchUrl}${searchParamsStringify(pagerBuilder)}`;

    pager.next = {
      url: url,
      // mousedown: dataLayer.buildPaginationClickEvent(pagerBuilder.page),
    }
  }

  if (currentPage > 2) {
    page = currentPage - 2;
  }

  if (pages > 1) {
    while (pager.pages.length <= pageNumbers && page <= pages) {
      let pagerBuilder = Object.assign({}, searchParams);
      pagerBuilder.page = page;
      if (pagerBuilder.page === 1) {
        pagerBuilder.page = null;
      }

      let url = `${searchUrl}${searchParamsStringify(pagerBuilder)}`;

      pager.pages.push({
        url: url,
        text: page,
        isCurrent: page === parseInt(currentPage)
        // mousedown: dataLayer.buildPaginationClickEvent(page),
      });
      page ++;
    }
  }

  return pager;
}

export default buildSearchListPager;